@if (whiteLabel){
    <router-outlet>
    </router-outlet>
    @defer{
        <app-spinner></app-spinner>
    } @placeholder {
        <div></div>
    }
}
@defer {
    @if (whiteLabel) {
        <app-media-lib></app-media-lib>
    }
} @placeholder {

}


